/** @jsxImportSource solid-js */

import { customElement, noShadowDOM } from "solid-element";
import { Button } from "#root/lib/palette/components/button.solid.js";
import { Icons } from "#root/lib/palette/components/icons.solid.js";

const bugURL = "https://www.projectcallisto.org/oops";

export function BugReportButton() {
  return (
    <div class="absolute bottom-3 right-3">
      <div class="group relative flex">
        <Button
          class="flex items-center bg-brand-700 text-white max-w-fit"
          onClick={() => {
            const newTab = window.open(bugURL, "_blank");
            if (newTab) {
              newTab.focus();
            }
          }}
        >
          <Icons.Bug class="mr-1 h-4 w-4" /> Report an Issue
        </Button>
      </div>
    </div>
  );
}

customElement("bug-report-button", {}, () => {
  noShadowDOM();

  return <BugReportButton />;
});
